var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTaxList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.6767 42.5076V44.8153H7.98438V7.43066H10.2921V42.5076H35.6767Z",
    fill: "#BCB7C6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7997 40.3845V42.6922H35.492H10.1074V7.61531V5.30762H12.4151V40.3845H37.7997Z",
    fill: "#A1D4FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2305 3.18457V5.49226V40.5692H37.6151H39.9228V3.18457H12.2305Z",
    fill: "#ECEBED"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33 28.1074H37.6154V30.4151H33V28.1074Z",
    fill: "#00ACC1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33 23.4922H37.6154V25.7999H33V23.4922Z",
    fill: "#00ACC1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M33 18.877H37.6154V21.1846H33V18.877Z",
    fill: "#00ACC1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M33 14.2617H37.6154V16.5694H33V14.2617Z",
    fill: "#00ACC1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0762 28.1074H32.9992V30.4151H20.0762V28.1074Z",
    fill: "#26C6DA"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0762 23.4922H32.9992V25.7999H20.0762V23.4922Z",
    fill: "#26C6DA"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0762 18.877H32.9992V21.1846H20.0762V18.877Z",
    fill: "#26C6DA"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0762 14.2617H32.9992V16.5694H20.0762V14.2617Z",
    fill: "#26C6DA"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M33 30.416H37.6154V32.7237H33V30.416Z",
    fill: "#A1D4FF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M33 25.7998H37.6154V28.1075H33V25.7998Z",
    fill: "#A1D4FF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M33 21.1846H37.6154V23.4923H33V21.1846Z",
    fill: "#A1D4FF"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M33 16.5693H37.6154V18.877H33V16.5693Z",
    fill: "#A1D4FF"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M33 11.9541H37.6154V14.2618H33V11.9541Z",
    fill: "#A1D4FF"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0762 30.415H32.9992V32.7227H20.0762V30.415Z",
    fill: "#BDE1FF"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0762 25.7998H32.9992V28.1075H20.0762V25.7998Z",
    fill: "#BDE1FF"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0762 21.1846H32.9992V23.4923H20.0762V21.1846Z",
    fill: "#BDE1FF"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0762 16.5693H32.9992V18.877H20.0762V16.5693Z",
    fill: "#BDE1FF"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0762 11.9541H32.9992V14.2618H20.0762V11.9541Z",
    fill: "#BDE1FF"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0775 30.4156V32.7233H14.5391V11.9541H20.0775V14.2618V16.5695V18.8772V21.1849V23.4926V25.8003V28.1079V30.4156Z",
    fill: "#07CC66"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1547 30.415C44.1747 30.415 45.0009 31.2412 45.0009 32.2612C45.0009 33.2812 44.1747 34.1073 43.1547 34.1073C42.1357 34.1073 41.3086 33.2812 41.3086 32.2612C41.3086 31.2412 42.1357 30.415 43.1547 30.415Z",
    fill: "#FFD400"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M4.38462 35.0303C5.14985 35.0303 5.76923 35.6506 5.76923 36.4149C5.76923 37.1792 5.14985 37.7995 4.38462 37.7995C3.62031 37.7995 3 37.1792 3 36.4149C3 35.6506 3.62031 35.0303 4.38462 35.0303Z",
    fill: "#FFD400"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8466 24.415C44.2297 24.415 44.5389 24.7252 44.5389 25.1073C44.5389 25.4895 44.2297 25.7997 43.8466 25.7997C43.4645 25.7997 43.1543 25.4895 43.1543 25.1073C43.1543 24.7252 43.4645 24.415 43.8466 24.415Z",
    fill: "#C73B10"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4618 4.56934C42.8449 4.56934 43.1541 4.87949 43.1541 5.26164C43.1541 5.6438 42.8449 5.95395 42.4618 5.95395C42.0797 5.95395 41.7695 5.6438 41.7695 5.26164C41.7695 4.87949 42.0797 4.56934 42.4618 4.56934Z",
    fill: "#C73B10"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0009 42.415C42.384 42.415 42.6932 42.7252 42.6932 43.1073C42.6932 43.4895 42.384 43.7997 42.0009 43.7997C41.6187 43.7997 41.3086 43.4895 41.3086 43.1073C41.3086 42.7252 41.6187 42.415 42.0009 42.415Z",
    fill: "#C73B10"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5223 8.55782C36.5223 8.79966 36.4771 9.00366 36.3866 9.17074C36.2953 9.33874 36.1752 9.47351 36.0266 9.57597C35.261 10.1051 33.8475 9.85354 33.082 9.33782L33.5177 8.4729C33.5335 8.4932 33.586 8.53105 33.6746 8.58736C33.8903 8.72656 34.193 8.8401 34.4426 8.90859C34.6033 8.9529 34.7666 8.97505 34.9319 8.97505C35.2826 8.97505 35.458 8.86797 35.458 8.65474C35.458 8.57351 35.4322 8.50705 35.3796 8.45443C34.9921 8.07385 33.6445 8.12222 33.333 7.31259C33.2317 7.04499 33.233 6.614 33.3902 6.29074C33.7682 5.5185 34.953 5.11843 36.395 5.96397L35.9602 6.78643C35.9481 6.76982 35.9056 6.73936 35.8327 6.69505C35.7608 6.65074 35.6693 6.60459 35.5614 6.55659C35.3378 6.45616 35.0689 6.37474 34.8173 6.37474C34.4629 6.37474 34.2856 6.49382 34.2856 6.73197C34.2856 6.80397 34.3041 6.8649 34.3429 6.9129C34.5901 7.23246 35.6241 7.22591 36.1622 7.69013C36.422 7.91231 36.5223 8.21342 36.5223 8.55782Z",
    fill: "#FD6814"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2032 7.23324H31.8952V8.03724H30.2032V8.95017H32.2285V9.82155H29.2109V5.52832H32.1741V6.39878H30.2032V7.23324Z",
    fill: "#FD6814"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7146 7.70494L28.1536 9.82155H27.0838L26.1949 8.40001L25.3059 9.82155H24.2296L25.6687 7.70494L24.1816 5.52832H25.2579L26.1949 7.00986L27.1318 5.52832H28.2026L26.7146 7.70494Z",
    fill: "#FD6814"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2236 8.85971H20.8871L20.5612 9.82155H19.5449L21.1114 5.52832H22.0058L23.5723 9.82155H22.5559L22.2236 8.85971ZM21.5581 6.65909L21.0448 8.17663H22.0602L21.5581 6.65909Z",
    fill: "#FD6814"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M17.936 6.39878V9.82155H16.9445V6.39878H15.6328V5.52832H19.242V6.39878H17.936Z",
    fill: "#FD6814"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M6.92278 3.646C7.30585 3.646 7.61508 3.95615 7.61508 4.3383C7.61508 4.72046 7.30585 5.03061 6.92278 5.03061C6.54062 5.03061 6.23047 4.72046 6.23047 4.3383C6.23047 3.95615 6.54062 3.646 6.92278 3.646Z",
    fill: "#C73B10"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M5.53801 41.0303C5.92109 41.0303 6.23032 41.3404 6.23032 41.7226C6.23032 42.1047 5.92109 42.4149 5.53801 42.4149C5.15586 42.4149 4.8457 42.1047 4.8457 41.7226C4.8457 41.3404 5.15586 41.0303 5.53801 41.0303Z",
    fill: "#C73B10"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M4.15325 22.5693C4.53632 22.5693 4.84555 22.8795 4.84555 23.2616C4.84555 23.6438 4.53632 23.954 4.15325 23.954C3.77109 23.954 3.46094 23.6438 3.46094 23.2616C3.46094 22.8795 3.77109 22.5693 4.15325 22.5693Z",
    fill: "#C73B10"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M30.23 35.0305H14.5377C14.2828 35.0305 14.0762 34.8239 14.0762 34.569C14.0762 34.314 14.2828 34.1074 14.5377 34.1074H30.23C30.485 34.1074 30.6916 34.314 30.6916 34.569C30.6916 34.8239 30.485 35.0305 30.23 35.0305Z",
    fill: "#4A78FF"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9992 36.8772H14.5377C14.2828 36.8772 14.0762 36.6706 14.0762 36.4156C14.0762 36.1607 14.2828 35.9541 14.5377 35.9541H26.9992C27.2542 35.9541 27.4608 36.1607 27.4608 36.4156C27.4608 36.6706 27.2542 36.8772 26.9992 36.8772Z",
    fill: "#4A78FF"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6916 38.7229H14.5377C14.2828 38.7229 14.0762 38.5163 14.0762 38.2613C14.0762 38.0064 14.2828 37.7998 14.5377 37.7998H24.6916C24.9465 37.7998 25.1531 38.0064 25.1531 38.2613C25.1531 38.5163 24.9465 38.7229 24.6916 38.7229Z",
    fill: "#4A78FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaxList);
export default __webpack_public_path__ + "static/media/tax_list.1ab17a856cad5c4514897d6176a4855a.svg";
export { ForwardRef as ReactComponent };